import { create } from 'zustand';

export enum ThumbsPages {
  Root = 0,
  FeedbackPositive = 1,
  FeedbackNegative = 2,
  ThankScreen = 3
}

interface Store {
  page: ThumbsPages;
  open: boolean;
  setPage(page: ThumbsPages): void;
  toggle(open?: boolean): void;
  llamaVariant: 'sad' | 'default';
  setLlamaVariant(variant: 'sad' | 'default'): void;
}

export const useThumbsStore = create<Store>((set, get) => ({
  page: ThumbsPages.Root,
  open: false,
  setPage: page => set({ page }),
  toggle: open => set({ open: open === undefined ? !get().open : open }),
  llamaVariant: 'default',
  setLlamaVariant: variant => set({ llamaVariant: variant })
}));
